import { useQuery } from "react-query";
import { crmFiltersApi } from "@/react/api/crmFiltersApi";

// Based on different contexts, we will fetch different filter configurations
// For example workflows might have different filters than the crm
// Audience filters might hide some filters
export const AvailableContexts = {
  MEMBER_DIRECTORY: "member_directory",
} as const;

export type AvailableContextsType =
  (typeof AvailableContexts)[keyof typeof AvailableContexts];

export const useFilterKitConfiguration = ({
  context,
}: {
  context: AvailableContextsType;
}) => {
  if (!Object.values(AvailableContexts).includes(context)) {
    throw new Error(`Invalid context: ${context}`);
  }

  return useQuery({
    queryKey: ["filterKitConfiguration", context],
    queryFn: () => {
      if (context === AvailableContexts.MEMBER_DIRECTORY) {
        return crmFiltersApi.configuration();
      }

      return Promise.resolve(null);
    },
    enabled: Boolean(context),
  });
};
